import { render, staticRenderFns } from "./NvChapterList.vue?vue&type=template&id=57d512cc&scoped=true&"
import script from "./NvChapterList.vue?vue&type=script&lang=js&"
export * from "./NvChapterList.vue?vue&type=script&lang=js&"
import style0 from "./NvChapterList.vue?vue&type=style&index=0&id=57d512cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d512cc",
  null
  
)

export default component.exports